// extracted by mini-css-extract-plugin
export default {"display_left":"style_display_left__AqbNi","display_right":"style_display_right__7qwyp","table_wrap":"style_table_wrap__GaYp+"};